import React from "react";
import { Modal, Button, Table } from "react-bootstrap";

export default function InvoiceModal({ data, show, handleClose }) {
  const isAdmin = localStorage.getItem("isAdmin");

  const onPrintInvoice = () => window.print();

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      className="invoice-modal max-heighted-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body className="custom-scrollbar">
        <div className="invoice-content p-2" id="print-screen">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div className="d-flex align-items-center flex-grow-1">
              <img src="/images/logo.png" alt="" />
              <h5 className="ms-2">
                Anytime
                <br /> Childcare
              </h5>
            </div>
            <div className="flex-grow-1 mt-md-0 mt-3">
              <h5>Invoice</h5>
              <p className="mb-0">
                <span className="label-heading">Invoice No: </span>
                <span>{data.invoiceNo ? data.invoiceNo : "Not Generated"}</span>
              </p>
              <p className="mb-0">
                <span className="label-heading">Dated on: </span>
                <span>{data.datedOn}</span>
              </p>
            </div>
          </div>
          <hr />
          <div className="row g-0">
            <div className="col-md-6">
              <p className="label-heading mb-0">Parent/Guardian</p>
              <p>
                {data.booking_parent.firstName +
                  " " +
                  data.booking_parent.lastName}
              </p>
              <p className="label-heading mb-0">Email</p>
              <p>{data.booking_parent.email}</p>
              <p className="label-heading mb-0">Postcode</p>
              <p>{data.booking_guardian.guardianPostcode}</p>
              <p className="label-heading mb-0">Status</p>
              <p className={"status " + data.status}>{data.status}</p>
            </div>
            <div className="col-md-6">
              <p className="label-heading mb-0">Child</p>
              <p>
                {data.booking_child.firstName +
                  " " +
                  data.booking_child.lastName}
              </p>
              <p className="label-heading mb-0">Phone Number</p>
              <p>{data.booking_guardian.guardianPhone}</p>
              <p className="label-heading mb-0">Address</p>
              <p>{data.booking_guardian.guardianAddress1}</p>
              {data.booking_guardian.guardianAddress2 && (
                <p>{data.booking_guardian.guardianAddress2}</p>
              )}
            </div>
          </div>
          <hr />
          <div className="mb-3">
            <p className="label-heading mb-1">Booking Dates</p>
            <div className="d-flex flex-wrap">
              {data.dates.map((item, index) => {
                return (
                  <p key={index} className="booking-date me-1 mb-1">
                    {item}
                  </p>
                );
              })}
            </div>
          </div>
          <Table bordered responsive>
            <thead>
              <tr>
                <td>
                  <p className="mb-0">Activity</p>
                </td>
                <td>
                  <p className="mb-0">Booking Days</p>
                </td>
                <td>
                  <p className="mb-0">Per Session Cost</p>
                </td>
                <td>
                  <p className="mb-0">Total</p>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p className="mb-0">{data.booking_service.title}</p>
                </td>
                <td>
                  <p className="mb-0">{data.dates.length}</p>
                </td>
                <td>
                  <p className="mb-0">£{data.booking_service.sessionPrice}</p>
                </td>
                <td>
                  <p className="mb-0">£{data.total}</p>
                </td>
              </tr>
            </tbody>
          </Table>
          <div>
            <p className="label-heading mb-0">Notes</p>
            <p>{data.notes ? data.notes : "N/A"}</p>
          </div>
        </div>
      </Modal.Body>
      {isAdmin != 0 && (
        <Modal.Footer>
          <Button variant="primary" size="sm" onClick={onPrintInvoice}>
            Print Invoice
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}
